import { render, staticRenderFns } from "./WithTitleNotificationSection.vue?vue&type=template&id=febc4f54&scoped=true&"
import script from "./WithTitleNotificationSection.vue?vue&type=script&lang=ts&"
export * from "./WithTitleNotificationSection.vue?vue&type=script&lang=ts&"
import style0 from "./WithTitleNotificationSection.vue?vue&type=style&index=0&id=febc4f54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febc4f54",
  null
  
)

export default component.exports